import { Reducer, AnyAction, Dispatch } from 'redux';
import { DeviceCtxState } from './type';
import { listDevices } from '../../api/device';

export const SET_DEVICES = 'device/setDevices';
export const SET_CUR_DEVICE = 'device/setCur';

const defaultState: DeviceCtxState = {
    curDeviceKey: '',
    devices: [],
    loaded: false,
};

const reducer: Reducer<DeviceCtxState> = (state: DeviceCtxState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case SET_DEVICES:
            return {
                ...state,
                devices: action.payload.devices,
                loaded: true,
                // 首次加载时, 如果 curDeviceKey 还是空, 自动选第一台.
                curDeviceKey:
                    state.curDeviceKey ||
                    (action.payload.devices[0]?.deviceKey ?? ''),
            };
        case SET_CUR_DEVICE:
            return { ...state, curDeviceKey: action.payload.deviceKey };
        default:
            return state;
    }
};

// 并发守卫: 同 material store, 防 loaded 置位前的重复触发.
let loading = false;

const actions = {
    setCur(deviceKey: string) {
        return { type: SET_CUR_DEVICE, payload: { deviceKey } };
    },
    load() {
        return async (dispatch: Dispatch) => {
            if (loading) return;
            loading = true;
            try {
                const res = await listDevices({ page: 1, pageSize: 200 });
                dispatch({
                    type: SET_DEVICES,
                    payload: { devices: res.list || [] },
                });
            } catch {
                dispatch({ type: SET_DEVICES, payload: { devices: [] } });
            } finally {
                loading = false;
            }
        };
    },
};

export default { reducer, actions };
